/**
 * @generated SignedSource<<5b9d1fd57f3b7e053df6a54c051fb304>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateProjectCustomerOrderNotesInput = {
  customerOrderNotes: string;
  id: string;
};
export type ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation$variables = {
  input: UpdateProjectCustomerOrderNotesInput;
};
export type ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation$data = {
  readonly updateProjectCustomerOrderNotes: {
    readonly customerOrderNotes: string | null | undefined;
    readonly id: string;
  };
};
export type ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation = {
  response: ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation$data;
  variables: ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "updateProjectCustomerOrderNotes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerOrderNotes",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "71067f6c45238f400a216451147bc245",
    "id": null,
    "metadata": {},
    "name": "ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectDetailsViewUpdateProjectCustomerOrderNotesMutation(\n  $input: UpdateProjectCustomerOrderNotesInput!\n) {\n  updateProjectCustomerOrderNotes(input: $input) {\n    id\n    customerOrderNotes\n  }\n}\n"
  }
};
})();

(node as any).hash = "d8830441f8f48368450a8ecce278d56a";

export default node;
